/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2026-06-23 21:42:08
 * @LastEditTime: 2026-06-24 02:20:00
 * @Description: Windows MT5 download choices. All Windows MT5 download entries open the choice UI first.
 */
export const WINDOWS_MT5_DOWNLOAD_ROUTE = '/windows-download/';

export const WINDOWS_MT5_GL_SMOOTH_DOWNLOAD_LINK =
  'https://goldlabelglobal.com/GL.MT5.202608.zip';

// Original Windows MT5 download link used by the website.
export const WINDOWS_MT5_OFFICIAL_DOWNLOAD_LINK =
  'https://gold-label.oss-cn-beijing.aliyuncs.com/goldlabel5setup.202608.exe';

export function getWindowsMt5DownloadDecision() {
  return {
    isWindowsDesktop: true,
    shouldShowChoice: true,
    reason: 'always_show_choice',
  };
}

export function getWindowsMt5DownloadRouteUrl() {
  if (typeof window === 'undefined') {
    return WINDOWS_MT5_DOWNLOAD_ROUTE;
  }

  return new URL(WINDOWS_MT5_DOWNLOAD_ROUTE, window.location.origin).toString();
}

export function openWindowsMt5OfficialInstaller() {
  if (typeof window === 'undefined') return;
  window.location.href = WINDOWS_MT5_OFFICIAL_DOWNLOAD_LINK;
}

export function openWindowsMt5SmoothInstaller() {
  if (typeof window === 'undefined') return;
  window.location.href = WINDOWS_MT5_GL_SMOOTH_DOWNLOAD_LINK;
}
